<article #postTemplate class="animation-height">
  <header class="mb-3">
    <a [href]="post.link" target="_blank"><h1 class="text-2xl font-bold">{{ post.title.rendered }}</h1></a>
    <span class="text-gray-800">{{ post.date | date:'longDate' }}</span>
    <div>
      <a
        *ngFor="let tag of post.tags" [href]="tag.link"
        class="rounded-full bg-gray-400 text-sm px-3 inline-block mb-2 mr-2 !text-white hover:bg-gray-600 transition-colors"
      >
        <span>{{ tag.name | titlecase }}</span>
      </a>
    </div>
  </header>
  <footer [innerHtml]="post.excerpt.rendered"></footer>
</article>
